import { styled } from '@pata-app/themes';

export const MainContainer = styled.main`
  flex-grow: 1;

  width: 100%;

  margin-top: 70px;
`;
